import { inject, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { SnackBarComponent, SnackBarType } from '@shared/components/snack-bar/snack-bar.component';
import { SNACK_BAR_DURATION } from '../../../app.constants';


export type SnackBarParams = {
    text: string;
    duration?: number;
    type?: SnackBarType;
};

@Injectable({
    providedIn: 'root',
})
export class SnackBarService {
    private readonly snackBar: MatSnackBar = inject(MatSnackBar);

    public open(params: SnackBarParams): void {
        if (!params.type) {
            params.type = SnackBarType.Success;
        }

        const config: MatSnackBarConfig = {
            data: params,
            horizontalPosition: 'center',
            panelClass: [`app-snack-bar-${params.type}`],
            duration: params.duration || SNACK_BAR_DURATION,
        } as MatSnackBarConfig;

        this.snackBar.openFromComponent(SnackBarComponent, config);
    }
}
